import {
  ATTACHMENTS_TYPES,
  CHAT_EXTERNAL_TYPE,
  CHAT_SUB_TYPES,
  MESSAGE_STATUS,
  MESSAGE_TYPES,
  TRANSCRIPTION_STATUS,
} from '../../../../../enum/constants';
import { PlannerItem } from '../../../stacked-sidebar/components/planner-v2/planner-v2.interface';
import { IPromProduct } from '../../../../prom/prom.interface';

export interface Attachment {
  type: ATTACHMENTS_TYPES;
  shown_url?: string;
  url?: string;
  key?: string | number;
  id?: string | number;
  original_id?: string | number;
  loading?: boolean;
  error?: boolean;
  mime_type?: string;
  mimeType?: string; // NOTE THIS ONLY FOR UI FIX, DON'T USE IT, IT WILL BE FIXED LATER
  name?: string;
  size?: number;
  video_gif?: boolean;
  video_sticker?: boolean;
  round?: boolean;
  voice?: boolean;
  sticker?: boolean;
  sizes?: Sizes;
  duration?: number;
  waveform?: Buffer;
  alt?: string;
  nosound?: boolean;
  postUrl?: string;
  caption?: string;
}

interface Sizes {
  width: number;
  height: number;
}

export interface MessageCreatedByUser {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  avatar_url: string;
}

export interface Message {
  id: string;
  chat_id: string;
  attachments?: { array: Attachment[] };
  phone?: string;
  is_read?: boolean;
  text?: string;
  created_at: string;
  deleted_at: string;
  created_by?: string;
  created_by_user?: MessageCreatedByUser | null;
  tails?: boolean;
  status?: MESSAGE_STATUS;
  is_image?: boolean;
  is_pinned?: boolean;
  is_ai?: boolean;
  is_sent_crm?: boolean;
  type_message: MESSAGE_TYPES;
  external_id?: string;
  x_data?: {
    id?: number;
    text?: string;
    sender?: MessageSender;
    last_edit_date?: string;
    edit_hide?: string;
    logs?: MessageLog[];
    fwd_from?: MessageForwardedFrom;
    reply_to?: MessageReplyTo;
    post?: InstSharedPost;
    value?: {
      id?: string;
      text?: string;
      media?: {
        id?: string;
      };
      parent_id?: string;
    };
    reaction?: MessageReactions;
    planner?: PlannerItem;
    product?: IPromProduct;
    tiktok?: {
      comment_id?: string;
      video_id?: string;
    };
    transcription?: MessageTranscription;
    translations?: Record<string, MessageTranslation>;
    /** Interpolation params of a SYSTEM message, whose `text` is an i18n key */
    params?: Record<string, string | null>;
  };
}

export interface MessageTranscription {
  status: TRANSCRIPTION_STATUS;
  text?: string;
  error?: string;
  updated_at: string;
}

export interface MessageTranslation {
  text: string;
  source: 'text' | 'transcription';
  updated_at: string;
}

export interface TranslateMessageResponse {
  language: string;
  text: string;
}

export interface MessageLog {
  text: string;
  updated_at: string;
}

export interface MessageSender {
  id?: string | number;
  name?: string;
  photo_id?: string | number;
  url?: string;
  color?: string;
}

export interface MessageData {
  price?: string;
  comment?: string;
  photo?: string;
  link?: string;
  title?: string;
  term_id?: number;
  term_title?: string;
  term_price?: string;
}

export interface MessageForwardedFrom {
  from_original_id?: string | number;
  from_id?: string;
  from_name?: string;
  from_photo_id?: string | number;
  from_photo_url?: string;
}

export interface MessageReplyTo {
  from_chat_original_id?: string | number;
  from_chat_id?: string;
  from_name?: string;
  from_another_chat_type?: CHAT_SUB_TYPES;
  to_msg_original_id?: string | number;
  to_msg_id?: string;
  to_msg_text?: string;
  to_msg_media?: Attachment;
  to_name?: string;
  to_story_id?: string;
  to_story_s3_url?: string;
  to_story_url?: string;
  is_quote?: boolean;
  is_another_chat?: boolean;
  is_fwd?: boolean;
  fwd_name?: string;
  media_type?: string;
  media_size?: string;
}

export enum BTN_ACTIONS {
  RIA_AUCTION_ACCEPT = 'RIA_AUCTION_ACCEPT',
  RIA_AUCTION_DECLINE = 'RIA_AUCTION_DECLINE',
  RIA_TRADE_ACCEPT = 'RIA_TRADE_ACCEPT',
  RIA_TRADE_DECLINE = 'RIA_TRADE_DECLINE',
}

export enum riaMessageTypesNumbersMap {
  RIA_AUCTION_ACCEPT = 32,
  RIA_AUCTION_DECLINE = 33,
  RIA_TRADE_ACCEPT = 38,
  RIA_TRADE_DECLINE = 39,
}

export enum RIA_MESSAGE_TYPES_ACTION {
  RIA_AUCTION_ACCEPT = MESSAGE_TYPES.RIA_AUCTION_AGREED,
  RIA_AUCTION_DECLINE = MESSAGE_TYPES.RIA_AUCTION_AGREED,
  RIA_TRADE_ACCEPT = MESSAGE_TYPES.RIA_TRADE_ACCEPT_BUYER,
  RIA_TRADE_DECLINE = MESSAGE_TYPES.RIA_TRADE_DECLINE_BUYER,
}

export interface IMenuMessage {
  title: string;
  icon: string;
  is_svg?: boolean;
  action: (event: MouseEvent) => void;
  is_lines?: boolean;
}

export const riaAuctionMessageTypes: MESSAGE_TYPES[] = [
  MESSAGE_TYPES.RIA_AUCTION,
  MESSAGE_TYPES.RIA_AUCTION_AGREED,
  MESSAGE_TYPES.RIA_AUCTION_ACCEPT,
  MESSAGE_TYPES.RIA_AUCTION_DECLINE,
];

export const riaTradeMessageTypes: MESSAGE_TYPES[] = [
  MESSAGE_TYPES.RIA_TRADE,
  MESSAGE_TYPES.RIA_TRADE_ACCEPT_BUYER,
  MESSAGE_TYPES.RIA_TRADE_DECLINE_BUYER,
  MESSAGE_TYPES.RIA_TRADE_ACCEPT,
  MESSAGE_TYPES.RIA_TRADE_DECLINE,
];

export const riaTradeAcceptMessageTypes: MESSAGE_TYPES[] = [
  MESSAGE_TYPES.RIA_TRADE_ACCEPT_BUYER,
  MESSAGE_TYPES.RIA_TRADE_ACCEPT,
];

export const riaTradeDeclineMessageTypes: MESSAGE_TYPES[] = [
  MESSAGE_TYPES.RIA_TRADE_DECLINE_BUYER,
  MESSAGE_TYPES.RIA_TRADE_DECLINE,
];

export const riaTradePhotoMessageTypes: MESSAGE_TYPES[] = [
  MESSAGE_TYPES.RIA_TRADE,
  MESSAGE_TYPES.RIA_TRADE_ACCEPT_BUYER,
  MESSAGE_TYPES.RIA_TRADE_DECLINE_BUYER,
];

export const riaMessageTypes: MESSAGE_TYPES[] = [...riaAuctionMessageTypes, ...riaTradeMessageTypes];

export const replyMessageTypes: CHAT_EXTERNAL_TYPE[] = [
  CHAT_EXTERNAL_TYPE.TELEGRAM_BOT,
  CHAT_EXTERNAL_TYPE.TELEGRAM_USER,
  CHAT_EXTERNAL_TYPE.WHATSAPP,
];

export const editMessageTypes: CHAT_EXTERNAL_TYPE[] = [
  CHAT_EXTERNAL_TYPE.TELEGRAM_BOT,
  CHAT_EXTERNAL_TYPE.TELEGRAM_USER,
];

export const noEditAttachmentTypes: ATTACHMENTS_TYPES[] = [
  ATTACHMENTS_TYPES.STICKER,
  ATTACHMENTS_TYPES.ROUND,
  ATTACHMENTS_TYPES.UNKNOWN,
];

// temporary map for tooltip
export const attachmentsTooltipMap: Record<string, string> = {
  [ATTACHMENTS_TYPES.IMAGE]: 'image',
  [ATTACHMENTS_TYPES.VIDEO]: 'video',
  gif: 'gif',
  [ATTACHMENTS_TYPES.AUDIO]: 'audio',
  voice: 'voice',
  [ATTACHMENTS_TYPES.ROUND]: 'round',
  [ATTACHMENTS_TYPES.STICKER]: 'sticker',
  [ATTACHMENTS_TYPES.DOCUMENT]: 'file',
};

export interface InstSharedPost {
  id: string;
  caption?: string;
  media_url: string;
  media_type: string;
  children?: { data: PostChildren[] };
  post_url?: string;
  comment?: string;
  attachments?: Attachment[];
  video_id?: string;
}

interface PostChildren {
  id: string;
  media_url: string;
  media_type: string;
}

export interface MessageReactionsUser {
  original_id?: string;
  photo_id?: string;
  url?: string;
  name?: string;
}

export interface MessageReactionsEmoji {
  key: string;
  emoji?: string;
  custom_emoji_id?: string;
  count: number;
  users: MessageReactionsUser[];
  my?: boolean;
  last_date?: number;
}

export interface MessageReactions {
  emojis?: MessageReactionsEmoji[];
  can_see_list?: boolean;
  emoji?: string;
  reaction?: string;
  action?: string;
  x_data?: any;
}

export const RELOAD_MEDIA_TYPE_CHATS: CHAT_EXTERNAL_TYPE[] = [CHAT_EXTERNAL_TYPE.OLX];

export const AVATAR_REACTIONS_EXTERNAL_TYPES: CHAT_EXTERNAL_TYPE[] = [CHAT_EXTERNAL_TYPE.TELEGRAM_USER];
